// src/services/api.js
import axios from 'axios';

// In development, proxy handles the API URL
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://app.jegosuab.eu/api'
  : '/api';  // Changed to just /api for development

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add employee ID header if employee is logged in
    const employeeData = localStorage.getItem('employeeData');
    if (employeeData && config.url?.includes('/employee/')) {
      try {
        const employee = JSON.parse(employeeData);
        config.headers['x-employee-id'] = employee.id;
      } catch (e) {
        console.error('Error parsing employee data:', e);
      }
    }
    // Token is handled via HTTP-only cookies
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if it's an employee route
      if (window.location.pathname.startsWith('/employee/')) {
        window.location.href = '/employee/login';
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
